import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import ActivityReportList from './activity-report-list';
import PageHeader from '@/components/PageHeader';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Activity Reports">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>            
            <Breadcrumb.Item >Activities</Breadcrumb.Item>
            <Breadcrumb.Item active>Reports</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <ActivityReportList />
    </Panel>
  );
};

export default Page;
